import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { f2 } from '../copyFlow2'
import { Gear } from './icons'
import { WORKSPACE } from './Page'
import { usePlanNav } from './planNav'
import { Wordmark } from './Wordmark'
import { MastTab } from './MastTab'

/**
 * Desktop global header (flow3 §1): 72px, brand left (to Browse), Browse / Plan in the middle, partner presence and
 * Settings right. Hidden under 1024px, where screens keep their phone navigation.
 */
export function AppHeader({ center, presence }: { center?: ReactNode; presence?: ReactNode }) {
  const settings = usePlanNav()[3]
  return (
    <header data-review-id="app-header" className="sticky top-0 z-30 hidden border-b border-line bg-bg lg:block">
      <div className={`${WORKSPACE} grid h-[72px] grid-cols-[1fr_auto_1fr] items-center`}>
        <div className="justify-self-start"><Wordmark /></div>
        <div className="justify-self-center">{center ?? <MainNav />}</div>
        <nav aria-label={f2('nav.settings')} className="flex items-center gap-1 justify-self-end">
          {presence}
          <Link to={settings.to} aria-current={settings.on ? 'page' : undefined} className="press inline-flex min-h-11 items-center gap-2 rounded-[12px] px-3 text-[15px] font-semibold text-ink hover:bg-sunk">
            <Gear size={18} />
            {settings.label}
          </Link>
        </nav>
      </div>
    </header>
  )
}

/** Browse / Saved / Itineraries in the header's middle, as the masthead tabs. */
function MainNav() {
  const opts = usePlanNav().slice(0, 3)
  return (
    <nav aria-label={f2('nav.browse')} className="flex items-center gap-8">
      {opts.map((o) => <MastTab key={o.label} {...o} />)}
    </nav>
  )
}
